<template>
  <ReportingChartContainer
    :parameters="chartParameters"
    :selected-parameters="chartSelectedParameters"
    class="reporting-chart-container"
    @onChangeSelectedParameters="onChangeSelectedParameters"
  >
    <ReportingColumnChart
      v-show="chartType === 'column'"
      class="m-t-30"
      :group-by="groupBy"
      :data="insightColumnChartData && insightColumnChartData.defaultData"
      :drilleddown-data="columnDrilledDownData"
      :selected-parameters="chartSelectedParameters"
      :chart-drilldown-path="chartDrilleddownPath"
      :show-loader="insightColumnChartData && insightColumnChartData.showLoader"
      @onChartDrilldownChange="onChartDrilldownChange"
      @onDrilldown="onDrilldown"
    />

    <ReportingPieChart
      :class="{'pie-chart--move-out': chartType !== 'pie'}"
      :data="insightPieChartData && insightPieChartData.defaultData"
      :drilleddown-data="pieDrilledDownData"
      :group-by="groupBy"
      :selected-parameters="chartSelectedParameters"
      :chart-drilldown-path="chartDrilleddownPath"
      :show-loader="insightPieChartData && insightPieChartData.showLoader"
      :selected-chart-type="chartType"
      :selected-group-by="selectedGroupBy"
      @onChartDrilldownChange="onChartDrilldownChange"
      @onDrilldown="onDrilldown"
    />
  </ReportingChartContainer>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

import ReportingColumnChart from './ReportingColumnChart';
import ReportingPieChart from  './ReportingPieChart';
import ReportingChartContainer from './ReportingChartContainer';

export default {
  name: 'ReportingCharts',
  components: {
    ReportingColumnChart,
    ReportingPieChart,
    ReportingChartContainer,
  },
  props: {
    groupBy: {
      type: Object,
      default() {
        return {};
      }
    },
    chartType: {
      type: String,
      default: ''
    },
    selectedGroupBy: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  computed: {
    ...mapGetters('reporting', [
      'activeInsight',
      'activeInsightData',
      'chartParameters',
      'chartSelectedParameters',
    ]),
    ...mapGetters('reporting', {
      chartDrilleddownPath: 'activeInsightGroupHierarchy'
    }),
    insightColumnChartData() {
      return this.activeInsightData?.chartData['column'];
    },
    insightPieChartData() {
      return this.activeInsightData?.chartData['pie'];
    },
    pieDrilledDownData() {
      return this.insightPieChartData && this.insightPieChartData.drilleddownData;
    },
    columnDrilledDownData() {
      return this.insightColumnChartData && this.insightColumnChartData.drilleddownData;
    },
    groupByState() {
      return this.activeInsight.settings.groupSettings;
    },
    columnChartState() {
      return this.groupByState.chartStates['column'];
    },
    pieChartState() {
      return this.groupByState.chartStates['pie'];
    },
  },
  methods: {
    ...mapActions('reporting', [
      'setChartDrilldownState',
      'setSelectedParameters',
      'getChartDrilldownData'
    ]),
    onChartDrilldownChange({ drilleddownTo, chartType }) {
      this.setChartDrilldownState({ 
        drilleddownTo, 
        chartType,
        groupBy: this.groupBy.field
      });
    },
    onChangeSelectedParameters(selectedParameters) {
      this.setSelectedParameters({
        groupBy: this.groupBy.field,
        selectedParameters
      });
    },
    onDrilldown({
      drilldowns,
      aggregateBy,
      chartPoint,
      chartType,
      initialGroupBy
    }) {
      this.$emit('getChartDrilldownData', {
        drilldowns,
        aggregateBy,
        chartPoint,
        chartType,
        initialGroupBy
      });
    }
  },
};
</script>

<style lang="scss">
.reporting-chart-container {
  position: relative;
}

// This is used to hide pointer cursor when drilldown is disabled for a series
// It's a hack b/c highcharts by default shows cursor pointer when drilldown is enabled
// We enable drilldown for all series since highcharts does not allow to update the series' event handler for drilldowns
.highcharts-custom--disable-drilldown {
  .highcharts-drilldown-point, .highcharts-drilldown-axis-label {
    text-decoration: none !important;
    cursor: default !important;
  }
}


.highcharts-xaxis-label-custom {
  display: block;
  text-align: right;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}

.highcharts-xaxis-label--first {
  max-width: 100px;
}

.highcharts-custom--disable-drillup {
  .highcharts-drillup-button {
    display: none !important;
  }
}

.pie-chart--move-out {
  position: absolute;
  left: -5000px;
  top: -10000px;
}
</style>